<template>
  <SimpleLoadingChartContainer
    :chartOptions="selectedChartOptions"
    :loading="fetchAuxEnginesDataLoading"
    loadingText="Loading RHP chart data..."
  >
    <template #header>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span class="rhp-chart-title">Auxiliary Engines</span>
        <ThemedRadioGroup v-model="selectedChart" row :value="selectedChart">
          <v-radio value="power" color="var(--color-text)">
            <template #label>
              <span class="radio-label">Power</span>
            </template>
          </v-radio>
          <v-radio value="runningHours" color="var(--color-text)">
            <template #label>
              <span class="radio-label">Running Hours</span>
            </template>
          </v-radio>
        </ThemedRadioGroup>
      </div>
    </template>
  </SimpleLoadingChartContainer>
</template>
    
    
    <script>
import { mapGetters, mapState } from "vuex";
import SimpleLoadingChartContainer from "../../../../core/SimpleLoadingChartContainer.vue";
import ThemedRadioGroup from "../../../../core/ThemedRadioGroup.vue";
export default {
  name: "RHPChart",
  components: {
    SimpleLoadingChartContainer,
    ThemedRadioGroup,
  },
  data: function () {
    return {
      selectedChart: "power",
    };
  },
  computed: {
    ...mapGetters("vesselInformation/voyageAuxEnginesModule", [
      "runningHoursChartOptions",
      "powerChartOptions",
    ]),
    ...mapState("vesselInformation/voyageAuxEnginesModule", [
      "fetchAuxEnginesDataLoading",
    ]),
    selectedChartOptions() {
      if (this.selectedChart == "power") {
        return this.powerChartOptions;
      } else {
        return this.runningHoursChartOptions;
      }
    },
  },
  methods: {},
  mounted() {},
};
</script>
  
<style scoped>
.rhp-chart-title {
  font-size: 18px;
  font-weight: bold;
  color: var(--color-text);
}

.radio-label {
  color: var(--color-text);
  font-size: 14px;
  font-weight: bold;
}
</style>
